<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader title="Drivers Management" />
  
      <!-- Add New Driver Button -->
      <button class="add-driver-btn" @click="navigateToAddDriver">Add New Driver</button>
  
      <!-- Table Structure -->
      <table id="driverTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Car Number</th>
            <th>Status</th>
            <th>Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(driver, index) in drivers" :key="index">
            <td>{{ driver.id }}</td>
            <td>{{ driver.name }}</td>
            <td>{{ driver.carNumber }}</td>
            <td :class="driver.isSuspend ? '' : ''">
              {{ driver.isSuspend ? 'Suspended' : 'Active' }}
            </td>
            <td class="action-buttons">
              <button data-tooltip="Edit" @click="handleEdit(driver)">
                <img src="@/assets/edit_icon.png" alt="Edit">
              </button>
              <button 
                data-tooltip="Delete" 
                @click="handleDelete(driver)"
                class="delete-btn"
              >
                <img src="@/assets/delete_icon.png" alt="Delete">
              </button>
              <button 
                :data-tooltip="driver.isSuspend ? 'Activate' : 'Suspend'" 
                @click="handleToggleStatus(driver)"
                :class="driver.isSuspend ? 'activate-btn' : 'suspend-btn'"
              >
                <img 
                  :src="driver.isSuspend ? 
                   require('@/assets/suspend_icon.png') : 
                    require('@/assets/activate_icon.png')"  
                  :alt="driver.isSuspend ? 'Activate' : 'Suspend'"
                >
                {{ driver.isSuspend ? '' : '' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        drivers: [],
        currentDate: "",
        currentTime: "",
      };
    },
    mounted() {
      this.updateDateTime(); 
      setInterval(this.updateDateTime, 1000); 
      this.fetchDrivers(); 
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.currentTime = now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
      async fetchDrivers() {
    try {
        this.$root.isLoading = true;
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const branchId = localStorage.getItem('branchId'); 
        const appId = localStorage.getItem('appId'); 
        
        if (!branchId) {
            throw new Error('Branch ID not found in localStorage');
        }

        const response = await fetch(`${this.$BASE_API_URL}/api/drivers?appId=${appId}?branchId=${branchId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch drivers');
        }

        const { data } = await response.json();
        this.drivers = data;
    } catch (error) {
        console.error('Error fetching drivers:', error);
        this.$toast.error('Failed to load drivers data');
    } finally {
        this.$root.isLoading = false;
        this.loading = false;
    }
},
      navigateToAddDriver() {
         if (!this.$hasPermission('create drivers')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ name: "AddDriverCompamiesComponent" });
      },
      handleEdit(driver) {
         if (!this.$hasPermission('edit drivers')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ 
          name: "EditDriverCompamiesComponent", 
          params: { id: driver.id } 
        });
      },
      async handleDelete(driver) {
         if (!this.$hasPermission('delete drivers')){
        this.$toast.error('Not Permitted');
        return;
    }
        if (!confirm(`Are you sure you want to delete ${driver.name}?`)) {
          return;
        }
        
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/drivers/${driver.id}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            throw new Error('Failed to delete driver');
          }

          this.drivers = this.drivers.filter(d => d.id !== driver.id);
          this.$toast.success('Driver deleted successfully');
        } catch (error) {
          console.error('Error deleting driver:', error);
          this.$toast.error('Failed to delete driver');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async handleToggleStatus(driver) {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const endpoint = driver.isSuspend 
            ? `/api/drivers/activate/${driver.id}`
            : `/api/drivers/suspend/${driver.id}`;

          const response = await fetch(`${this.$BASE_API_URL}${endpoint}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            throw new Error('Failed to update driver status');
          }

          driver.isSuspend = !driver.isSuspend;
          this.$forceUpdate();
        } catch (error) {
          console.error('Error updating driver status:', error);
          this.$toast.error('Failed to update driver status');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      }
    },
  };
  </script>
  
  <style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  th, td {
    border: 1px solid;
    padding: 8px;
    text-align: left;
  }
  .add-driver-btn {
    float: right;
    margin-right: .5rem;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: 0.5rem;
  }
  .action-buttons {
    display: flex;
    gap: 8px;
    border-bottom: hidden;
    border-right: hidden;
  }
  .action-buttons button {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .action-buttons button:hover {
    transform: scale(1.05);
  }
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  /* Status colors */
  .text-success {
    color: #28a745;
  }
  .text-danger {
    color: #dc3545;
  }
  /* Button colors */
  .delete-btn img {
    filter: invert(20%) sepia(100%) saturate(500%) hue-rotate(300deg);
  }
  .suspend-btn {
    color: #dc3545;
  }
  .activate-btn {
    color: #28a745;
  }
  </style>